import { useEffect } from 'react';
import { useGetHomeLoansDashboardPageDataQuery } from 'src/services/graphql/generated/graphql';
import { MaybeLoanID } from 'src/common/types';
import { useUnauthorizedAccessGuard } from 'src/services/graphql/hooks/useUnauthorizedAccessGuard';
import { DatadogRUMService } from 'src/services/datadog/DatadogRUMService';
import { useTrackViewEvent } from '../analytics/view/useTrackViewEvent';
import { isUUID } from '../../../../utils/validators/isUUID';
import { useRedirectUserToDashboardBounce } from '../utils/useRedirectUserToDashboardBounce';

export const useMortgageDashboardState = ({ loanID }: { loanID: MaybeLoanID }) => {
    useRedirectUserToDashboardBounce(loanID);
    const isLoanIDInvalid = !isUUID(loanID);
    const { data, loading, error } = useGetHomeLoansDashboardPageDataQuery({
        variables: {
            id: loanID as string,
        },
        skip: isLoanIDInvalid,
    });
    useUnauthorizedAccessGuard(error);
    const { homeLoansDashboardByLoanId } = data ?? {};
    const { personalizedNextSteps, currentlySelectedLoan } = homeLoansDashboardByLoanId ?? {};
    const { currentState: status = null } = personalizedNextSteps ?? {};
    const { lead } = currentlySelectedLoan ?? {};
    const { id: leadID = null } = lead ?? {};

    useEffect(() => {
        const logDatadog = async () => {
            await DatadogRUMService.Client.getInstance().addAction(
                DatadogRUMService.CustomAction.DASHBOARD_PAGE_LOADED,
                {
                    loanID,
                    status,
                    error,
                }
            );
        };
        if (!loading && loanID) {
            logDatadog();
        }
    }, [loanID, status, error, loading]);

    useTrackViewEvent({
        leadID,
        loanID,
        loading,
        status,
    });
};
